import { render, staticRenderFns } from "./SeasonTicketHolder.vue?vue&type=template&id=635eb443&scoped=true"
import script from "./SeasonTicketHolder.vue?vue&type=script&lang=js"
export * from "./SeasonTicketHolder.vue?vue&type=script&lang=js"
import style0 from "./SeasonTicketHolder.vue?vue&type=style&index=0&id=635eb443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635eb443",
  null
  
)

export default component.exports